import type { AdminMeetingTemplateDto } from '@upme/contracts';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@upme/ui/components/alert-dialog';
import { Button } from '@upme/ui/components/button';
import { Input } from '@upme/ui/components/input';
import { useState } from 'react';
import { toast } from 'sonner';
import { useDeleteMeetingTemplate } from '../mutations';

interface Props {
  template: AdminMeetingTemplateDto;
  onDeleted?: () => void;
}

export function DeleteMeetingTemplateDialog({ template, onDeleted }: Props) {
  const [confirm, setConfirm] = useState('');
  const del = useDeleteMeetingTemplate();

  const canConfirm = confirm === template.slug;

  const handleConfirm = async () => {
    try {
      await del.mutateAsync(template.id);
      toast.success('Шаблон удалён');
      onDeleted?.();
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Не удалось удалить';
      toast.error(message);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="destructive" size="sm">
          Удалить
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Удалить шаблон «{template.title}»?</AlertDialogTitle>
          <AlertDialogDescription>
            Действие необратимо. Уже созданные встречи по этому шаблону не затрагиваются.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="my-4">
          <p className="text-sm mb-2">
            Для подтверждения введите <code className="bg-muted px-1 rounded">{template.slug}</code>:
          </p>
          <Input placeholder="Введите slug" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Отмена</AlertDialogCancel>
          <AlertDialogAction disabled={!canConfirm} onClick={handleConfirm}>
            Удалить
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
